import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./report-manager.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./report-manager.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ReportBaseComponent } from "../../../core/tools/report/shared/report-base/report-base.component";
import { AppControllerService } from "../../../app-controller.service";
import { ReportService } from "../report-form/report.service";
import { UserInformationService } from "../../services/user/user-information.service";
import { ReportFormBuilder } from "../report-form/report-form-builder";
let ReportManagerComponent = class ReportManagerComponent extends ReportBaseComponent {
    userInformationService;
    reportService;
    route;
    formBuilder;
    appControllerService;
    changeDetector;
    jobID;
    reportGroup;
    reportName;
    appId;
    componentType;
    uploadReport = false;
    canDownloadInPortal = false;
    referenceNumber;
    constructor(userInformationService, reportService, route, formBuilder, appControllerService, changeDetector) {
        super(userInformationService, reportService, route, formBuilder, appControllerService, changeDetector);
        this.userInformationService = userInformationService;
        this.reportService = reportService;
        this.route = route;
        this.formBuilder = formBuilder;
        this.appControllerService = appControllerService;
        this.changeDetector = changeDetector;
    }
    ngOnInit() {
        const report = new ReportFormBuilder(this.formBuilder);
        this.reportForm = report.initReportForm();
        this.reportForm.get("reportType")?.get("canDownloadInPortal")?.setValue(this.canDownloadInPortal);
        this.reportForm.get("reportType")?.get("uploadReport")?.setValue(this.uploadReport);
        this.reportForm.get("reportType")?.get("jobId")?.setValue(this.jobID);
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: ReportService },
        { type: ActivatedRoute },
        { type: FormBuilder },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        jobID: [{ type: Input }],
        reportGroup: [{ type: Input }],
        reportName: [{ type: Input }],
        appId: [{ type: Input }],
        componentType: [{ type: Input }],
        uploadReport: [{ type: Input }],
        canDownloadInPortal: [{ type: Input }],
        referenceNumber: [{ type: Input }]
    };
};
ReportManagerComponent = __decorate([
    Component({
        selector: "app-report-manager",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ReportManagerComponent);
export { ReportManagerComponent };
